<template>
	<div class="omapi-campaign-table__status">
		<component
			:is="allActive ? 'span' : 'a'"
			:href="allActive ? false : '#'"
			:class="`omapi-campaign-table__status-${allActive ? 'current' : 'option'}`"
			@click.prevent="handleClick('all')"
		>
			All Campaigns
		</component> ({{ totalCampaignsCount }}) |
		<component
			:is="publishActive ? 'span' : 'a'"
			:href="publishActive ? false : '#'"
			:class="`omapi-campaign-table__status-${publishActive ? 'current' : 'option'}`"
			@click.prevent="handleClick('published')"
		>
			Published
		</component> ({{ publishCount }}) |
		<component
			:is="pendingActive ? 'span' : 'a'"
			:href="pendingActive ? false : '#'"
			:class="`omapi-campaign-table__status-${pendingActive ? 'current' : 'option'}`"
			@click.prevent="handleClick('pending')"
		>
			Pending
		</component> ({{ pendingCount }}) |
		<component
			:is="draftActive ? 'span' : 'a'"
			:href="draftActive ? false : '#'"
			:class="`omapi-campaign-table__status-${draftActive ? 'current' : 'option'}`"
			@click.prevent="handleClick('draft')"
		>
			Drafts
		</component> ({{ draftCount }})
	</div>
</template>

<script lang="js">
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapMutations, mapActions, mapGetters } = createNamespacedHelpers('campaigns')

export default  {
	computed : {
		...mapState([
			'totalCampaignsCount',
			'totalFilteredCampaignsCount',
			'embedFilter',
		]),
		...mapGetters([
			'canResetFilters',
			'publishCount',
			'draftCount',
			'pendingCount',
			'enabledCampaignIds',
			'disabledCampaignIds',
		]),
		allActive () {
			return 'all' === this.embedFilter && !this.canResetFilters
		},
		publishActive () {
			return 'published' === this.embedFilter && !this.canResetFilters
		},
		pendingActive () {
			return 'pending' === this.embedFilter && !this.canResetFilters
		},
		draftActive () {
			return 'draft' === this.embedFilter && !this.canResetFilters
		},
	},
	methods : {
		...mapMutations([ 'setFilterValues', 'setEmbedFilter', 'resetFilter' ]),
		...mapActions([ 'refreshDashboard', 'fetchEnabledCampaignSlugs', 'fetchDisabledCampaignSlugs', 'resetFilters' ]),
		handleClick (status) {
			if (this[`${status}Active`]) {
				return
			}

			const complete = cb => {
				this.resetFilters({
					handler : (afterReset) => {
						this.setEmbedFilter(status)

						cb()

						afterReset()
					},
				})
			}

			switch (status) {
			case 'draft':
				return complete(() => {
					this.setFilterValues({
						status      : 'pause',
						campaignIds : this.disabledCampaignIds,
					})
				})
			case 'pending':
				// TODO: Figure this out.
				// return complete(() => {
				// 	this.setFilterValues({
				// 		status: 'pause',
				// 		campaignIds: this.enabledCampaignIds,
				// 	})
				// 	// OR
				// 	this.setFilterValues({
				// 		status: 'active',
				// 		campaignIds: this.disabledCampaignIds,
				// 	})
				// })
				break
			case 'published':
				return complete(() => {
					this.setFilterValues({
						status      : 'active',
						campaignIds : this.enabledCampaignIds,
					})
				})
			case 'all':
			default:
				// Fall-through
				break
			}

			return this.resetFilters()
		},
	},
}
</script>
